<h2 mat-dialog-title translate="Popup.ContactUs.Title"></h2>
<div mat-dialog-content>
  <p translate="Popup.ContactUs.Body"></p>
  <app-popup-support></app-popup-support>
</div>
<div mat-dialog-actions>
  <button class="btn btn-secondary" mat-dialog-close>{{ 'Global.Close' | translate }}</button>
</div>
